import { render } from "./MessageForm.vue?vue&type=template&id=1f2e2507"
import script from "./MessageForm.vue?vue&type=script&lang=js"
export * from "./MessageForm.vue?vue&type=script&lang=js"

import "./MessageForm.vue?vue&type=style&index=0&id=1f2e2507&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__